export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showTable({commit}) {
        commit('showTable');
    },
    showForm({commit}) {
        commit('showForm');
    },
}
